export default () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8089/banking-api'
  }
  if (process.env.NODE_ENV === 'lavras') {
    return 'http://192.168.121.222:8089/banking-api'
  }

  if (process.env.NODE_ENV === 'homolog') {
    return 'http://192.168.111.245:8089/banking-api'
  }

  if (process.env.NODE_ENV === 'staging') {
    return 'https://api-banking-vinhedo.equals.com.br/banking-api'
  }

  if (process.env.NODE_ENV === 'production') {
    return 'https://banking.equals.com.br/api/banking-api'
  }

  if (process.env.NODE_ENV === 'production-oci') {
    return 'https://api-banking.equals.com.br/banking-api'
  }
}



// WEBPACK FOOTER //
// ./build/http-requests/getNodeMiddlewareUrl.js